import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * The authenticated read probe. A token proves the credentials; only a real read
 * proves `ZOCDOC_BASE_URL` and the granted scopes. `schedulable_entities` is the cheapest such
 * read and carries no patient data — it is the practice's provider/location pairs, which is
 * also exactly what provider-link mapping (Z-2.x) will be seeded from.
 */
export const zocdocPingRead = oc.route({ method: 'GET', path: '/v2/zocdoc/ping-read' }).output(
  z.object({
    ok: z.boolean(),
    totalCount: z.number().optional(),
    entities: z
      .array(
        z.object({
          id: z.string(),
          npi: z.string().optional(),
          timeZone: z.string().optional(),
          mainSpecialtyName: z.string().optional(),
          goLiveAt: z.string().optional(),
        }),
      )
      .optional(),
    missingEnv: z.array(z.string()).optional(),
    status: z.number().optional(),
    requestId: z.string().optional(),
    error: z.string().optional(),
  }),
)
